import React from "react";
import './index.css';
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {Tool, Var} from "../../../App";
import Notif from "../../../Components/Notif";
import Label from "../../../Components/Control/Label";
import Separator from "../../../Components/Control/Separator";
import Select from "../../../Components/Control/Select";
import ValidationSpot from "../../../Components/Control/ValidationSpot";
import MyComponent from '../../../Components/MyComponent';

class ModalPrepareAlert extends MyComponent {
    constructor (props) {
        super(props);

        props.refer.current = this;

        this.state = {
            fields: {},
            error: false,
            bloodGroups: [{id: '', text: '...'},
                ...props.base.bloodGroups.map(item => {
                    return {id: item.id, text: item.name};
                })],
            username: `${Var.shuffle(undefined, 10)}`,
            password: `${Var.shuffle(undefined, 10)}`,
            step: 1,
            finalStep: 3,
        };

        this.ref = {
            modal: React.createRef(),
            bloodGroups: React.createRef(),
            patientBloodGroupId: React.createRef(),
            productBloodGroupId: React.createRef(),
            username: React.createRef(),
            password: React.createRef(),
            prev: React.createRef(),
            next: React.createRef(),
            submit: React.createRef(),
            close: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        bloodGroups: _ => {
            const {fields, data} = this.state;

            if (fields.patientBloodGroupId && fields.productBloodGroupId && fields.patientBloodGroupId[0].id && fields.productBloodGroupId[0].id) {
                if (fields.patientBloodGroupId[0].id !== data.patient.bloodGroupId)
                    return 'گروه خونی انتخاب شده بیمار دارای مغایرت می باشد. لطفا فرآیند آماده سازی را با دقت از اول آغاز کنید.';

                if (fields.productBloodGroupId[0].id !== data.product.bloodGroupId)
                    return 'فرآورده آماده شده دارای مغایرت می باشد. لطفا فرآیند آماده سازی را با دقت از اول آغاز کنید.';
            }

            return true;
        },
        patientBloodGroupId: x => Boolean(x && x[0]?.id) || 'گروه خونی بیمار انتخاب نشده.',
        productBloodGroupId: x => Boolean(x && x[0]?.id) || 'گروه خونی فرآورده انتخاب نشده.',
        username: x => Boolean(x) || 'نام کاربری وارد نشده است.',
        password: x => Boolean(x) || 'رمزعبور وارد نشده است.',
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields ||
            state.step !== nextState.step ||
            state.finalStep !== nextState.finalStep;
    }

    componentDidMount () {

    }

    render () {
        const {state} = this;

        return <Modal ref={this.ref.modal}
                      name={'ModalPrepareAlert'}
                      size={'medium'}
                      title={'هشدار امنیتی'}
                      error={state.error}>
            <ModalContent>
                <div className={'dis-f'}>
                    <div className={`step ${state.step === 1 ? 'show' : ''}`}>
                        <Label>کاربر گرامی در حال آماده سازی فرآورده با <span style={{color: 'var(--goo-red)'}}>گروه خونی متفاوت</span> هستید لطفا در صورت اطمینان روی گزینه ادامه کلیک کنید.</Label>
                    </div>
                    <Separator/>
                    <ValidationSpot ref={this.ref.bloodGroups} className={`step ${state.step === 2 ? 'show' : ''}`} validation={this.validations.bloodGroups}>
                        <Label>لطفا برای اطمینان بیشتر گروه خونی بیمار و فرآورده را دوباره انتخاب کنید.</Label>
                        <Select ref={this.ref.patientBloodGroupId} className={'pad-4 fb-10'} label={'گروه خونی بیمار'} options={state.bloodGroups} validation={this.validations.patientBloodGroupId} value={state.fields?.patientBloodGroupId} onChange={this.setField.bind(this, 'patientBloodGroupId')}/>
                        <Select ref={this.ref.productBloodGroupId} className={'pad-4 fb-10'} label={'گروه خونی فرآورده'} options={state.bloodGroups} validation={this.validations.productBloodGroupId} value={state.fields?.productBloodGroupId} onChange={this.setField.bind(this, 'productBloodGroupId')}/>
                    </ValidationSpot>
                    <Separator/>
                    <div className={`step ${state.step === 3 ? 'show' : ''}`}>
                        <Label>{this.props.user.userFirstName} عزیز <span style={{color: 'var(--goo-red)'}}>مسئولیت</span> آماده سازی این فرآورده برای بیمار <span style={{color: 'var(--goo-red)'}}>{state.data?.patient?.fullName || '-'}</span> به شماره پرونده <span style={{color: 'var(--goo-red)'}}>{state.data?.patient?.fileCode || '-'}</span> با شما می باشد جهت تایید نام کاربری و رمز عبور خود را وارد کنید.</Label>
                        <Input ref={this.ref.username} className={'pad-4 fb-10'} label={'نام کاربری'} id={state.username} validation={this.validations.username} value={state.fields?.username} onChange={this.setField.bind(this, 'username')}/>
                        <Input ref={this.ref.password} type={"password"} className={'pad-4 fb-10'} label={'رمزعبور'} id={state.password} validation={this.validations.password} value={state.fields?.password} onChange={this.setField.bind(this, 'password')}/>
                    </div>
                </div>
            </ModalContent>
            <ModalControls>
                {state.step !== 1 && <Button refer={this.ref.prev} className={'mar-4'} theme={'blue'} onClick={this.prevClickHandler.bind(this)}>قبل</Button>}
                {state.step < state.finalStep && <Button refer={this.ref.next} className={'mar-4'} theme={'blue'} onClick={this.nextClickHandler.bind(this)}>ادامه</Button>}
                {state.step === state.finalStep && <Button refer={this.ref.submit} className={'mar-4'} theme={'blue'} onClick={this.submitClickHandler.bind(this)}>تایید</Button>}
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    nextClickHandler () {
        switch (this.state.step) {
            case 2:
                const validate = Tool.validate(this.ref.patientBloodGroupId, this.ref.productBloodGroupId, this.ref.bloodGroups);

                if (validate === true) {
                    this.setState({step: this.state.step + 1});
                } else {
                    new Notif({message: validate.message, theme: 'error'}).show();
                }
                break;
            default:
                this.setState({step: this.state.step + 1});
                break;
        }
    }

    prevClickHandler () {
        this.setState({step: this.state.step - 1});
    }

    submitClickHandler () {
        const {props, state} = this;
        const validate = Tool.validate(this.ref.username, this.ref.password);

        if (state.finalStep === 1) {
            props.onSuccess(true);

            this.ref.modal.current.close();
        } else if (state.finalStep === 3 && validate === true) {
            props.onSuccess({
                username: state.fields?.username,
                password: state.fields?.password
            });

            this.ref.modal.current.close();
        } else {
            new Notif({message: validate.message, theme: 'error'}).show();
        }
    }

    open (data, action) {
        console.log(data);
        this.setState({
            data,
            action,
            fields: {},
            error: null,
            step: 1,
            finalStep: data.product.enzymeType === 3 ? 1 : 3
        });

        return this.ref.modal.current.open();
    }

    close (success) {
        this.ref.modal.current.close();

        if (success === true || this.state.updated)
            this.props.onSuccess();

        this.props.onClose();
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        base: state.base
    };
};

export default connect(mapStateToProps)(ModalPrepareAlert);